import { memo } from 'react';
import IframeResizer from 'iframe-resizer-react';

import { HIGH_VOLTAGE_BATTERY_MFE } from './microfrontendsConfig';

export const HighVoltageBatteryMfe = memo(({ assetId }: { assetId?: string }) => {
    return (
        <IframeResizer
            src={HIGH_VOLTAGE_BATTERY_MFE.url(assetId)}
            checkOrigin={false}
            style={{ width: '1px', minWidth: '100%', border: '0', minHeight: '350px' }}
            data-testid="high-voltage-battery-mfe-iframe"
        />
    );
});
